// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapperTableEvents {\n  margin: 16pt 0;\n  min-height: 50vh;\n}", ""]);
// Exports
module.exports = exports;
